// Styles for CarouselControlls go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledCarouselControls = styled.div``;
export const StyledCardSliderWrapper = styled.div`
  position: relative;
  .control-section {
    width: 100%;
  }
  .glide__arrow {
    position: absolute;
    top: 40%;
    z-index: 10;
    background-color: ${baseVariables.color['base20']};
    width: ${toRem(40)};
    height: ${toRem(40)};
    border-radius: 50%;
    border-color: transparent;
    font-size: ${toRem(24)};
    color: ${baseVariables.color['base10']};
    box-shadow: 0 ${toRem(4)} ${toRem(8)} 0 rgba(0, 0, 0, 0.1);
    &.is-disabled {
      display: none;
    }
  }

  .glide__arrows > .right-arrow {
    right: ${toRem(-24)};
  }

  .glide__arrows > .left-arrow {
    left: ${toRem(-24)};
  }

  .glide__arrows > .right-arrow,
  .glide__arrows > .left-arrow {
    .icon-arrow-left:before,
    .icon-arrow-right:before {
      position: absolute;
      top: 20%;
      left: 20%;
      right: 50%;
      bottom: 50%;
    }
  }

  .glide__slides {
    .glide__slide {
      width: 100%;
      list-style: none;
    }
  }

  .glide__track {
    position: relative;
    overflow: hidden;
  }
`;
export const StyledCardSliderTrack = styled.div``;
export const StyledCardSlideWrapper = styled.div`
  width: 100%;
  margin-right: ${toRem(-8)};
  margin-left: ${toRem(-8)};
  .glide__slide {
    &:not(:last-child, :first-child) {
      padding: 0;
    }
    &:first-child {
      padding-right: 0;
    }
    &:last-child {
      padding-left: 0;
    }
  }
`;
